export const LocalStorageConstants = {
  AppState: 'app_state'
};
